import React from 'react';
import Error from '@/components/Error';
import Login from '@/page/Login';
import QhbLogin from '@/page/CustomPage/qhb';
import CityQhbLogin2025 from '@/page/CustomPage/qhb/2025';
import RegionQhbLogin2025 from '@/page/CustomPage/qhb/2025/regionLogin';
import AutoLogin from '@/page/AutoLogin';
import Privacy from '@/page/Login/Privacy';
import Protocol from '@/page/Login/Protocol';
import BhyzLogin from '@/page/Login/Bhyz';
import ShareLink from '@/page/ShareLink';
import ShareSameLink from '@/page/ShareSameLink';
import WcbLogin from '@/page/CustomPage/wcb';
import WcbLogin2025 from '@/page/CustomPage/wcb2025';
import WcbSign from '@/page/CustomPage/wcb/sign';
import WcbSign2025 from '@/page/CustomPage/wcb2025/sign';
import OauthTokenLogin from '@/page/Login/OauthTokenLogin';
import ShareSameFullLink from '@/page/ShareSameFullLink';
import CityQhbLogin2026 from '@/page/CustomPage/qhb/2026';
import RegionQhbLogin2026 from '@/page/CustomPage/qhb/2026/regionLogin';
import DongguanLogin from '@/page/Login/DongGuan';
const ConstantRoutes = [
    //博海云著
    {
        resourcePageName: 'BhyzLogin',
        resource_name: 'BhyzLogin',
        resource_path: '/bhyz-login',
        element: <BhyzLogin></BhyzLogin>
    },
    {
        resource_path: '/login',
        element: <Login />,
        resourcePageName: '登录',
        resource_name: '登录'
    },
    // 启航杯恢复统一租户登录  2024年
    {
        resource_path: '/qhb_login',
        element: <QhbLogin />,
        resourcePageName: '启航杯租户登录',
        resource_name: '启航杯租户登录'
    },
    // 启航杯恢复统一租户登录 2026 市级登录
    {
        resource_path: '/2026_city_qhb_login/:id',
        element: <CityQhbLogin2026 />,
        resourcePageName: '启航杯租户登录',
        resource_name: '启航杯租户登录'
    },
    // 启航杯 2026 区级登录
    {
        resource_path: '/2026_region_qhb_login/:id',
        element: <RegionQhbLogin2026 />,
        resourcePageName: '启航杯租户登录',
        resource_name: '启航杯租户登录'
    },

    // 启航杯恢复统一租户登录 2025 区级登录
    {
        resource_path: '/2025_region_qhb_login/:id',
        element: <RegionQhbLogin2025 />,
        resourcePageName: '启航杯租户登录',
        resource_name: '启航杯租户登录'
    },
    // 启航杯恢复统一租户登录 2025 市级登录
    {
        resource_path: '/2025_city_qhb_login/:id',
        element: <CityQhbLogin2025 />,
        resourcePageName: '启航杯租户登录',
        resource_name: '启航杯租户登录'
    },

    // 五彩杯登录
    {
        resource_path: '/wcb_login',
        element: <WcbLogin />,
        resourcePageName: '五彩杯登录',
        resource_name: '五彩杯登录'
    },
    //2025-五彩杯登录
    {
        resource_path: '/2025_wcb_login',
        element: <WcbLogin2025 />,
        resourcePageName: '五彩杯登录',
        resource_name: '五彩杯登录'
    },
    // 五彩杯报名入口
    {
        resource_path: '/wcb_sign',
        element: <WcbSign />,
        resourcePageName: '五彩杯报名',
        resource_name: '五彩杯报名'
    },
    //2025-五彩杯报名入口
    {
        resource_path: '/2025_wcb_sign',
        element: <WcbSign2025 />,
        resourcePageName: '五彩杯报名',
        resource_name: '五彩杯报名'
    },
    {
        resource_path: '/auto_login',
        element: <AutoLogin />,
        resourcePageName: '自动登录',
        resource_name: '自动登录'
    },
    {
        resource_path: '/privacy_pc',
        element: <Privacy />,
        resourcePageName: '隐私政策',
        resource_name: '隐私政策'
    },
    {
        resource_path: '/protocol',
        element: <Protocol />,
        resourcePageName: '服务协议',
        resource_name: '服务协议'
    },
    {
        resource_path: '/error',
        element: <Error />,
        resourcePageName: 'error',
        resource_name: '页面找不到'
    },
    {
        resource_path: '/share-link/:type',
        element: <ShareLink />,
        resourcePageName: 'share',
        resource_name: '链接分享'
    },
    {
        resource_path: '/share-same-link',
        element: <ShareSameLink />,
        resourcePageName: 'share-same-link',
        resource_name: '同路由链接分享'
    },
    {
        resource_path: '/share-same-full-link',
        element: <ShareSameFullLink />,
        resourcePageName: 'share-same-full-link',
        resource_name: '同路由全链接分享'
    },
    //oauthToken登录
    {
        resourcePageName: 'OauthTokenLogin',
        resource_name: 'OauthTokenLogin',
        resource_path: '/oauth-login',
        element: <OauthTokenLogin></OauthTokenLogin>
    },
    {
        resourcePageName: 'DongguanLogin',
        resource_name: 'DongguanLogin',
        resource_path: '/dongguan-login',
        element: <DongguanLogin></DongguanLogin>
    }
];

export default ConstantRoutes;
